import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { useCallback } from 'react';
import type { AufgabeFuerKampagneErstellenMutation, AufgabeFuerKampagneErstellenMutationVariables } from './__generated__/AufgabeFuerKampagneErstellenMutation';

export const useAufgabeFuerKampagneErstellenMutation = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const [executeMutation, { loading, error }] = useMutation<AufgabeFuerKampagneErstellenMutation, AufgabeFuerKampagneErstellenMutationVariables>(gql`
    mutation aufgabeFuerKampagneErstellen($aufgabenId: UUID!, $objektId: UUID!) {
      aufgabeFuerKampagneErstellen(aufgabenId: $aufgabenId, objektId: $objektId) {
        id
      }
    }
  `, {
    onError: handleWithErrorNotification('Das Erstellen der Aktionsaufgabe ist fehlgeschlagen.'),
  });

  return {
    execute: useCallback((variables: AufgabeFuerKampagneErstellenMutationVariables) => executeMutation({ variables }), [executeMutation]),
    loading,
    error,
  };
};
